export enum SavingPeriod {
  OneToThree = 0,
  ThreeToSeven = 1,
  SevenToTen = 2,
  MoreThanTen = 3,
  ThreeToFive = 4,
  FiveToSeven = 5,
}

export enum RiskLevel {
  Unknown = -1,
  Careful = 0,
  Balanced = 1,
  Offensive = 2,
  ExtraOffensive = 3,
}

export enum RiskAppetite {
  Careful = 0,
  Balanced = 1,
  Offensive = 2,
}

export enum Behaviour {
  Sell = 0,
  Hold = 1,
  Buy = 2,
}

export enum AvailableLiquidity {
  From100To2000 = 0,
  From2000To10000 = 1,
  Over10000 = 2,
}

export enum ValuesEnum {
  None = 0,
  From0To150000 = 1,
  From150000To500000 = 2,
  MoreThan500000 = 3,
}

export enum Experience {
  Yes = 0,
  Some = 1,
  None = 2,
}

export enum SavingOfTotalEconomy {
  Smaller = 0,
  Larger = 1,
}

export enum Language {
  NB = 0,
  NN = 1,
}

export enum FundType {
  Rentefond = 0,
  Aksjefond = 1,
}
